export const skills = [
  "HTML",
  "CSS",
  "Sass/SCSS",
  "TailwindCSS",
  "JavaScript",
  "TypeScript",
  "ReactJS",
  "NextJS",
  "React Native",
  "Git",
  "Redux",
  "Zustand",
  "Firebase",
  "NodeJS",
  "ExpressJS",
  "FastAPI",
  "MongoDB",
  "Ethers.js",
  "Solidity",
  "Move",
  "Smart Contracts",
  "AI Integration",
  "AI Agents",
  "Gemini API",
  "Remotion",
];
